import { render, staticRenderFns } from "./SuggestedJurisdictionsRadio.vue?vue&type=template&id=23243e47&scoped=true&"
import script from "./SuggestedJurisdictionsRadio.vue?vue&type=script&lang=js&"
export * from "./SuggestedJurisdictionsRadio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../order-vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23243e47",
  null
  
)

export default component.exports